import api from "../api"
export default {
	async getComments(transactionID,limit,offset) {
		let value = await api.get(`/transactions/${transactionID}/comments?limit=${limit}&offset=${offset}`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data
		return data
	},
	async addComment(transactionID,values) {
		let value = await api.post(`/transactions/${transactionID}/comments`, {
			...values
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	async getCommentDetails(transactionID,commentID) {
		let value = await api.get(`/transactions/${transactionID}/comments/${commentID}`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data[0]
		return data
	},
	async updateComment(transactionID,commentID,values) {
		let value = await api.put(`/transactions/${transactionID}/comments/${commentID}`, {
			...values
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	async  getAllComments(limit,offset){
		let value = await api.get(`/transactions/all/comments?limit=${limit}&offset=${offset}`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data
		return data
	}
}